/**
 * @generated SignedSource<<725b5d8c4f84dc8197672e786abb92d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSellerItemsCarousel_item$data = {
  readonly seller: {
    readonly serviceId: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "PdpRespSellerItemsCarousel_item";
};
export type PdpRespSellerItemsCarousel_item$key = {
  readonly " $data"?: PdpRespSellerItemsCarousel_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSellerItemsCarousel_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItemsCarousel_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "e0e36a52e2265e780a617c1d683fb39d";

export default node;
